// gkc_hash_code : 01EV64EDXCZTX8ZCEMHJHDQ126
export const OPTION_LIST = [
  { content: '運営会社', link: 'https://athome-inc.jp/' },
  {
    content: 'プライバシーポリシー',
    link: 'https://hizakurige.com/privacy',
  },
  { content: 'よくあるご質問', link: 'https://hizakurige.com/#faq' },
];

export const settings = {
  infinite: true,
  slidesToShow: 3.5,
  autoplay: true,
  speed: 10000,
  autoplaySpeed: 10,
  cssEase: 'linear',
};
